import {Injectable} from "@angular/core";

@Injectable()
export class LocalStorageService {

  setItem(key:string, value:any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key:string) {
    return JSON.parse(localStorage.getItem(key));
  }

  clear() {
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/services/local-storage.service.ts